/* Pagination Helpers */
import _ from 'lodash';
import React from 'react';

export const getPages = (page, totalSize, sizePerPage) => {
    return _.times(page || 0, Number).map(n => ++n);
};

export function getHandlerTableChange (setQueryParams) {
    return (type, { page, sizePerPage, sortField, sortOrder, data }) => {
        const pageNumber = page || 1;

        setQueryParams(prev => {
            switch (type) {
                case 'sort':
                    return { ...prev, sortOrder, sortField };

                case 'pagination':
                    return { ...prev, pageNumber, pageSize: sizePerPage };

                default:
                    break;
            }
            return prev;
        });
    };
}

export function PleaseWaitMessage ({ entities }) {
    return <>{entities === null && <div className='text-center'>Por favor, espere...</div>}</>;
}

// eslint-disable-next-line eol-last, react/no-multi-comp
export function NoRecordsFoundMessage ({ entities }) {
    const list = entities === null ? [] : entities;

    return (
        <>
            {list.length === 0 && entities !== null && (
                <div className='text-center'>No se encontraron registros</div>
            )}
        </>
    );
}
